module.exports = __webpack_public_path__ + "img/sandX.f6b8e3c4.svg";